import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { DownloadButtonLabelContainer, DownloadButtonStyled, } from "./DownloadButton.styled";
const DownloadButton = React.memo((props) => {
    const { href, onClick, label, startIcon, endIcon } = props;
    return (_jsx(DownloadButtonStyled, { variant: "contained", href: href, onClick: onClick, startIcon: startIcon, endIcon: endIcon, children: _jsx(DownloadButtonLabelContainer, { children: label || "Download" }) }));
});
export { DownloadButton };
//# sourceMappingURL=DownloadButton.js.map